import React from 'react'

const CircularSpinner = () => {
    return (
        <div className="w-100 text-center">
            <div className="spinner-border" role="status">
                 <span className="sr-only"></span>
            </div>
        </div>
    )
}

export default CircularSpinner
